import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute, Route, Router, RouterModule } from '@angular/router';
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { AlertService } from '../../service/alert.service';
import { PasswordValidationComponent } from "../../shared/password-validation/password-validation.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-reset-password',
  standalone: true,
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css',
  imports: [CommonModule, FormsModule, RouterModule, AlertMessageComponent, PasswordValidationComponent, TranslateModule, MatIcon]
})
export class ResetPasswordComponent {

  newPassword : string = "";
  confirmPassword : string = "";
  token : string = "";
  loadForm : boolean = false;
  subbmited : boolean = false;
  isPasswordValid: boolean = false;
  
  // Controlla prima se nella query string ci sta il token
  // Se non ci sta mostra un errore nella console e non carica il form nel html
  // Se il token è presente allora carica il form

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.authService.verifyToken(this.token).subscribe((res) => { this.loadForm = res })
    });
  }

  constructor(private authService : AuthService, private route : ActivatedRoute, private alertService: AlertService, private router : Router,
    private translate: TranslateService){
  }

  onPasswordValidityChange(isValid: boolean) {
    this.isPasswordValid = isValid;
  }

  submit(): void {

    if(this.newPassword == this.confirmPassword){
      if(this.isPasswordValid){
        try {
          this.authService.resetPassword(this.token,this.newPassword).subscribe();
          this.subbmited=true;
        } catch (error) {
          this.subbmited=false;
          this.alertService.errorKey('auth.reset.errors.email-sending')
        }
      }
      else{
        this.alertService.errorKey('auth.errors.password-requirements')
      }
    }
    else{
      this.subbmited=false; 
      this.alertService.errorKey('auth.reset.errors.password-mismatch')
    }

  }

  toLogin() {
    this.router.navigate(['/login']);
  }

}
